var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddUserIcon = function SvgAddUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.813 8.307a4.153 4.153 0 1 0 0-8.307 4.153 4.153 0 0 0 0 8.307"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.813 8.307a4.153 4.153 0 1 0 0-8.307 4.153 4.153 0 0 0 0 8.307M8.654 14.428c0-.526.521-1.3 1.172-1.414.385-.066.963-.061.963-.061s-.1-1.275.447-1.754c-.021-.399-.495-.867-.495-.867S9.59 9.006 8.738 8.654a5.34 5.34 0 0 1-5.851 0A4.65 4.65 0 0 0 0 12.954v.664c0 .496.348.922.834 1.016 1.387.265 4.977.472 4.977.472s2.206.15 2.983.08c-.038-.225-.15-.345-.14-.758"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M12.3 12.47v4M10.3 14.47h4"
  })));
};
export default SvgAddUserIcon;